import { logger } from '../logging'

export function getDisplayCountry(country: string, locale = 'en') {
  try {
    const englishRegions = new Intl.DisplayNames([locale], { type: 'region' })

    return englishRegions.of(country)
  } catch (e) {
    if (e instanceof Error) {
      logger().warn(`Error getting display country for ${country} and locale: ${locale}`, { country, locale }, e)
    }
  }
}
